/* eslint-disable import/prefer-default-export */
export const BADGE_COLORS = {
    white: 'white',
    lightGray: 'light-gray',
    lightGrayTranslucent: 'light-gray-translucent',
    sunshine: 'sunshine',
};
